import React from 'react';
import LayoutAdsup from './LayoutAdsup';
import LayoutJvweb from './LayoutJvweb';
import { getTheme } from '../../utils/branding';

const Layout = ({ children }) => {
    const theme = getTheme();

    if (theme === 'jvweb') {
        return <LayoutJvweb>{children}</LayoutJvweb>;
    }

    return <LayoutAdsup>{children}</LayoutAdsup>;
};

export default Layout;
